
const _ = require('lodash');

const vb = require('./definition');

const {
	unwrapObservableAccessor,
} = require('./util');

vb.mapHas = (mapAccessor, message) => {
	return _.extend(vb.custom((v) => {
		const map = unwrapObservableAccessor(mapAccessor);
		return map.has(v);
	}), {
		message: () => message || 'выберите из списка',
	});
};
